export function DocumentFoldedIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3333 21C11.7778 21 10.8889 18 10.8889 16.5H2V18.75C2 19.9927 2.99492 21 4.22222 21H15.3333ZM15.3333 21C17.1743 21 18.6667 19.489 18.6667 17.625V9.75M18.6667 9.75H19.7778C21.0051 9.75 22 8.74264 22 7.5V5.25C22 4.00736 21.0051 3 19.7778 3H18.6667M18.6667 9.75V3M18.6667 3H6.44444C5.21714 3 4.22222 4.00736 4.22222 5.25V16.5M14.2222 7.5H8.66667M10.8889 12H8.66667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
